import { render, staticRenderFns } from "./passwordForm.vue?vue&type=template&id=089d8bf5&scoped=true&"
import script from "./passwordForm.vue?vue&type=script&lang=ts&"
export * from "./passwordForm.vue?vue&type=script&lang=ts&"
import style0 from "./passwordForm.vue?vue&type=style&index=0&id=089d8bf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089d8bf5",
  null
  
)

export default component.exports